import fs from 'fs'
import path from 'path'
import moment from 'moment'
import chalk from 'chalk'
import template from '../templates/migration'

export default function (table = null, name = null, update = false) {
    name = name || `${update ? 'update' : 'create'}_table_${table}`;
    const p = path.join(process.cwd(), 'api', 'src', 'migrations', `${moment().format('YYYYMMDDHHmmss')}_${name}.js`);
    console.log(chalk.yellow(`Generating ${name} migration to ${p}`));
    fs.writeFileSync(p, template(table, update))
}
